import { render, staticRenderFns } from "./boardFilter.vue?vue&type=template&id=7dc66421&scoped=true&"
import script from "./boardFilter.vue?vue&type=script&lang=js&"
export * from "./boardFilter.vue?vue&type=script&lang=js&"
import style0 from "./boardFilter.vue?vue&type=style&index=0&id=7dc66421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc66421",
  null
  
)

export default component.exports